<template>
  <div class="modal-bg" @click.stop>
    <div class="modal-content" @click.stop>
      <div class="modal-header">
        <h3>
          <i class="uil-envelope-alt"></i>
          {{ $t('general.send_message') }}
        </h3>
        <button class="modal-close-btn" @click="closeModal">
          <i class="uil-times"></i>
        </button>
      </div>

      <div class="modal-body">
        <!-- Alert mesajı -->
        <div v-if="alertMessage" class="alert-container">
          <div :class="alertMessage.type === 'error' ? 'alert-danger' : 'alert-success'" class="alert">
            <i :class="alertMessage.type === 'error' ? 'uil-exclamation-triangle' : 'uil-check-circle'"></i>
            {{ alertMessage.text }}
            <button class="alert-close" @click="removeAlertMessage">
              <i class="uil-times"></i>
            </button>
          </div>
        </div>

        <!-- Mesaj Formu -->
        <div class="message-form">
          <div class="form-group">
            <label class="form-label"> {{ $t('general.your_message') }}</label>
            <textarea
                v-model="form.content"
                :placeholder="$t('general.your_message')"
                class="form-textarea"
                rows="6"
            ></textarea>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button class="btn btn-secondary" @click="closeModal">
          {{ $t('general.cancel') }}
        </button>
        <button
            :disabled="loading || !form.content.trim()"
            class="btn btn-primary"
            @click="sendMessage"
        >
          <i v-if="loading" class="uil-spinner"></i>
          <i v-else class="uil-message"></i>
          {{ loading ? $t('general.sending') : $t('general.send') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import generalMixin from "@/core/mixin/general.mixin.js";

export default {
  name: "SendMessage",
  mixins: [generalMixin],
  data() {
    return {
      form: {
        content: "",
      },
      loading: false,
      alertMessage: null,
    };
  },
  props: {
    userId: {
      type: Number,
      required: true
    },
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },

    removeAlertMessage() {
      this.alertMessage = null;
    },

    checkValidation() {
      this.alertMessage = null;

      if (!this.form.content || this.form.content.trim() === '') {
        this.alertMessage = {
          type: 'error',
          text: this.$t("general.message_content_required")
        };
        return false;
      }

      return true;
    },

    sendMessage() {
      if (!this.checkValidation()) {
        return;
      }

      this.loading = true;
      this.alertMessage = null;

      let form = this.form;
      let user_id = this.userId;
      let sender_user_id = this.authUser.id;
      let formData = new FormData();
      formData.append("message", form.content);
      formData.append("sender_user_id", sender_user_id);

      let groupFormData = new FormData();
      groupFormData.append("users[]", [user_id]);
      axios.post('api/store-group', groupFormData)
          .then((response) => {
            formData.append("message_group_id", response.data.id);
            axios.post('api/send-message',
                formData, {
                  headers: this.apiHeaders,
                })
                .then((response) => {
                  this.alertMessage = {
                    type: 'success',
                    text: this.$t('general.message_sent_successfully')
                  };
                  this.loading = false;

                  // Başarılı mesajdan sonra modalı kapat
                  setTimeout(() => {
                    this.closeModal();
                  }, 1500);
                })
                .catch((error) => {
                  console.error('Error sending message:', error);
                  this.alertMessage = {
                    type: 'error',
                    text: this.$t('general.message_sent_error')
                  };
                  this.loading = false;
                })
          })
          .catch((error) => {
            console.error('Error creating group:', error);
            this.alertMessage = {
              type: 'error',
              text: this.$t('errors.500')
            };
            this.loading = false;
          })
    }
  }
};
</script>

<style scoped>
.modal-bg {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10001;
}

.modal-content {
  background: #fff;
  border-radius: 12px;
  width: 90%;
  max-width: 500px;
  max-height: 90vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #e9ecef;
  background: #f8f9fa;
}

.modal-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #495057;
  display: flex;
  align-items: center;
  gap: 8px;
}

.modal-header h3 i {
  color: #007bff;
}

.modal-close-btn {
  background: none;
  border: none;
  font-size: 20px;
  color: #6c757d;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  transition: all 0.2s;
}

.modal-close-btn:hover {
  background: #e9ecef;
  color: #495057;
}

.modal-body {
  padding: 24px;
  overflow-y: auto;
  flex: 1;
}

.alert-container {
  margin-bottom: 20px;
}

.alert {
  padding: 12px 16px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
  position: relative;
  font-size: 14px;
}

.alert-success {
  background: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
}

.alert-danger {
  background: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
}

.alert i {
  font-size: 16px;
}

.alert-close {
  background: none;
  border: none;
  color: inherit;
  cursor: pointer;
  padding: 0;
  margin-left: auto;
  font-size: 14px;
  opacity: 0.7;
  transition: opacity 0.2s;
}

.alert-close:hover {
  opacity: 1;
}

.message-form {
  margin-top: 20px;
}

.form-group {
  margin-bottom: 20px;
}

.form-label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #495057;
  font-size: 14px;
}

.form-textarea {
  width: 100%;
  padding: 12px;
  border: 1.5px solid #e0e6ed;
  border-radius: 8px;
  font-size: 14px;
  line-height: 1.5;
  resize: vertical;
  min-height: 120px;
  transition: border-color 0.2s;
  box-sizing: border-box;
}

.form-textarea:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.1);
}

.form-textarea::placeholder {
  color: #6c757d;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 20px 24px;
  border-top: 1px solid #e9ecef;
  background: #f8f9fa;
}

.btn {
  padding: 10px 20px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 6px;
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-secondary {
  background: #6c757d;
  color: #fff;
}

.btn-secondary:hover:not(:disabled) {
  background: #5a6268;
}

.btn-primary {
  background: #007bff;
  color: #fff;
}

.btn-primary:hover:not(:disabled) {
  background: #0056b3;
}

.btn i {
  font-size: 14px;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.uil-spinner {
  animation: spin 1s linear infinite;
}

/* Responsive */
@media (max-width: 768px) {
  .modal-content {
    width: 95%;
    margin: 20px;
  }

  .modal-header,
  .modal-body,
  .modal-footer {
    padding: 16px;
  }

  .form-textarea {
    min-height: 100px;
  }
}
</style>
